module.exports = __webpack_public_path__ + "components/page-footer/static/snow-forecast__logo--white-965cced0e500e02f7b395140396eb637.png";